import React from 'react';
import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Tag, { TagProps } from './Tag';

interface Props {
	tags: TagProps[];
}
const TagGroup = (props: Props) => {
	const classes = useStyles();

	return (
		<Box className={classes.wrapper}>
			{props.tags.map((tagProps, idx) => (
				<Tag key={idx} {...tagProps} />
			))}
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			display: 'flex',
			flexDirection: 'row',
			flexWrap: 'wrap',
			'& > *': {
				marginTop: theme.spacing(1),
				marginRight: theme.spacing(1),
			},
		},
	}),
);

export default TagGroup;
